import {useState,useEffect} from 'react'
import CurrencyAdminDialogs from '../../common/components/admin/CurrencyAdminDialogs'
import CurrencyCard from '../../common/components/admin/CurrencyCard'
import { createService } from '../../common/services/serviceFactory'

function CurrencySection() {

    const [actualCurrencies, setCurrencies] = useState([])
    const [selectedCurrency, setSelectedCurrency] = useState({})

    const [createOpenDialog, setCreateOpenDialog] = useState(false)
    const [updateOpenDialog, setUpdateOpenDialog] = useState(false)

    const [updateCurrencyToDeliever, setUpdateCurrencyToDeliever] = useState(selectedCurrency)

    useEffect(() => {
        const currencyService = createService('currencies');
        const token = localStorage.getItem("accessToken");
        currencyService.getAll(token)
            .then((data) => { setCurrencies(data) })
            .catch(error => console.error("Error fetching currencies:", error));
    }, []);

    const deleteCurrency = async (_id) => {
        const currencyService = createService('currencies');
        const token = localStorage.getItem("accessToken");
        try {
            await currencyService.delete(_id, token);
            setCurrencies(prevCurrencies => prevCurrencies.filter(currency => currency._id !== _id));
        } catch (error) {
            console.error("Error deleting currency:", error);
        }
    };

  return (
    <div>
        <div className='flex justify-center'>
            <button
                className='createButton'
                onClick={()=>setCreateOpenDialog(true)}
            >
                Añadir Moneda Aceptada
            </button>
        </div>
        <div style={{gap: "15px"}} className="flex justify-space-evenly flex-wrap">
        {actualCurrencies.map( (currency, key) => (
            <div onClick={()=>{
                    console.log(currency);
                    setSelectedCurrency(currency);
                    setUpdateCurrencyToDeliever(currency)
            }}>
                <CurrencyCard
                    key={key}
                    currency={currency}
                    updateOpenDialog={updateOpenDialog}
                    setUpdateOpenDialog={setUpdateOpenDialog}
                    deleteCurrency={deleteCurrency}
                />
            </div>
        ))}
        </div>

        <CurrencyAdminDialogs
            allCurrency = {actualCurrencies}
            setAllCurrency = {setCurrencies}
            selectedCurrency = {selectedCurrency}
            createOpenDialog = {createOpenDialog}
            setCreateOpenDialog = {setCreateOpenDialog}
            updateOpenDialog = {updateOpenDialog}
            setUpdateOpenDialog = {setUpdateOpenDialog}
            updateCurrencyToDeliever = {updateCurrencyToDeliever}
            setUpdateCurrencyToDeliever = {setUpdateCurrencyToDeliever}
        />
    </div>
  )
}

export default CurrencySection